import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.44194 5.55806C6.19786 5.31398 5.80214 5.31398 5.55806 5.55806C5.31398 5.80214 5.31398 6.19786 5.55806 6.44194L7.11612 8L5.55806 9.55806C5.31398 9.80214 5.31398 10.1979 5.55806 10.4419C5.80214 10.686 6.19786 10.686 6.44194 10.4419L8 8.88388L9.55806 10.4419C9.80214 10.686 10.1979 10.686 10.4419 10.4419C10.686 10.1979 10.686 9.80214 10.4419 9.55806L8.88388 8L10.4419 6.44194C10.686 6.19786 10.686 5.80214 10.4419 5.55806C10.1979 5.31398 9.80214 5.31398 9.55806 5.55806L8 7.11612L6.44194 5.55806Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
